import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  Typography,
  ListItemText,
  Box,
  useMediaQuery,
  Button,
  Menu,
  MenuItem,
  DialogActions,
  Dialog,
  DialogTitle,
  BottomNavigation,
  BottomNavigationAction,
  DialogContent,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutThunk } from "../../redux/slices/userSlice";
import ProfileIcon from "../ProfileIcon";
import Logo from "../../assets/logo/logo192.png";
const Navbar = () => {
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:960px)");
  const [value, setValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const cart = useSelector((state) => state?.student?.cartCount);
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.data?.user);

  // const Logo =
  //   "https://t4.ftcdn.net/jpg/04/70/53/77/360_F_470537798_1glJRnX4XK5sl556D0B9P6zK9dVPLJqZ.jpg";

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCancelLogout = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    setOpenDialog(true);
  };

  const handleConfirmLogout = async () => {
    const logout = await dispatch(logoutThunk());
    if (logout.payload.success) {
      navigate("/login");
    }

    handleMenuClose();
    setOpenDialog(false);
  };

  const menuItems = user
    ? [
        ...(user.role === "teacher"
          ? [{ text: "Video-Upload", path: "/dashboard/video-upload" }]
          : []),
        ...(user.role === "student"
          ? [{ text: "My Courses", path: "/student/purchased" }]
          : []),
      ]
    : [
        { text: "Sign Up", path: "/signup" },
        { text: "Login", path: "/login" },
      ];

  return (
    <Box
      sx={{
        padding: 4,
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "white",
          boxShadow: "none",
          borderBottom: "1px solid #ddd",
        }}
      >
        <Toolbar>
          {/* Logo */}
          <Link to={"/"}>
            <img
              src={Logo}
              alt="Logo"
              style={{ height: 55, marginRight: 20 }}
            />
          </Link>
          {/* Mobile View Navbar */}
          {isMobile ? (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <IconButton color="inherit" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            </Box>
          ) : (
            // Desktop View Navbar
            <Box
              display="flex"
              flexGrow={1}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Button
                color="inherit"
                sx={{
                  textTransform: "capitalize",
                  color: "black",
                  fontWeight: "bold",
                }}
                onClick={() => navigate("/")}
              >
                Home
              </Button>
              <Button
                color="inherit"
                sx={{
                  textTransform: "capitalize",
                  color: "black",
                  fontWeight: "bold",
                }}
                onClick={() => navigate("/aboutus")}
              >
                About Us
              </Button>

              <Button
                color="inherit"
                sx={{
                  textTransform: "capitalize",
                  color: "black",
                  fontWeight: "bold",
                }}
                onClick={() => navigate("/contact-us")}
              >
                Contact Us
              </Button>
              {menuItems.map((item, index) => (
                <Button
                  key={index}
                  color="inherit"
                  onClick={() => navigate(item.path)}
                  sx={{
                    marginX: 1,
                    textTransform: "capitalize",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  {item.text}
                </Button>
              ))}

              {user ? (
                <ProfileIcon
                  onClick={handleProfileMenuOpen}
                  firstName={user?.firstName || user?.displayName}
                  image={user?.picture}
                  fallbackText={(user?.firstName || user?.displayName)
                    ?.charAt(0)
                    .toUpperCase()}
                />
              ) : (
                ""
              )}

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleMenuClose()}
              >
                <MenuItem onClick={() => navigate("/profile")}>
                  Profile
                </MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      {isMobile && (
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          showLabels
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: "#fff",
            borderTop: "1px solid #ddd",
          }}
        >
          {menuItems.map((item, index) => (
            <BottomNavigationAction
              key={index}
              label={item.text}
              icon={item.icon}
              onClick={() => navigate(item.path)}
            />
          ))}
          {/*  mobile navigation profile icon with menu */}
          {user ? (
            <ProfileIcon
              onClick={handleProfileMenuOpen}
              firstName={user?.firstName || user?.displayName}
              image={user?.picture}
            />
          ) : (
            ""
          )}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleMenuClose()}
          >
            <MenuItem onClick={() => navigate("/profile")}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </BottomNavigation>
      )}

      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer}>
        <Box
          width={250}
          role="presentation"
          onClick={toggleDrawer}
          onKeyDown={toggleDrawer}
        >
          <List>
            <ListItem button>
              <ListItemText primary="Courses" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Categories" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <Dialog open={openDialog} onClose={handleCancelLogout}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to logout?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLogout} sx={{ color: "#6D30ED" }}>
            Cancel
          </Button>
          <Button onClick={handleConfirmLogout} sx={{ color: "#6D30ED" }}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Navbar;
